import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Input, Button, Typography, App } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./ForgotPasswordPage.css";

const { Title, Text, Link } = Typography;

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const { message, notification } = App.useApp();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const sendResetLink = async () => {
    if (!email.trim()) {
      message.warning("Please enter your email or username");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/Auth/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
          }),
        }
      );

      const data = await response.json();
      setLoading(false);
      message.success("Password reset link sent to your email.");
      window.location.href = "/login";
    } catch (error) {
      setLoading(false);
      message.error("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="forgot-container">
      <Card className="forgot-card">
        <Button
          type="link"
          size="large"
          onClick={() => navigate(-1)}
          style={{
            padding: 0,
            marginBottom: 12,
            display: "flex",
            alignItems: "center",
            color: 'black'
          }}
        >
          <ArrowLeftOutlined />
        </Button>
        <div className="logo-container">
          <img src={require("../../assets/logo.png")} alt="logo" />
        </div>

        <Title level={3}>Forgot Password</Title>

        <Text type="secondary">
          Enter your email and we’ll send you a password reset link.
        </Text>

        <div className="form-item">
          <Text strong>Email or Username</Text>
          <Input
            placeholder="Enter your email or username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>

        <Button
          type="primary"
          block
          className="forgot-button"
          loading={loading}
          onClick={sendResetLink}
        >
          Send Reset Link
        </Button>

        <div className="signin-text">
          Remember your password? <Link href="/login">Sign in</Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
